import type { StorageKey } from "@exonn/storage";
import type { UserDataResource, UserResource } from "@exonn/js-sdk";

export const getUserDataPayload = <Payload = any>(
  user: UserResource,
  storageKey: StorageKey,
): Payload | undefined => {
  const userData = getUserData(user, storageKey);
  const payload = userData?.payload;
  if (payload) {
    return JSON.parse(payload) as Payload;
  }
  return undefined;
};

export const getUserDataTimestamp = (
  user: UserResource,
  storageKey: StorageKey,
): string | undefined => {
  const userData = getUserData(user, storageKey);
  return userData?.timestamp;
};

export const getUserData = (
  user: UserResource,
  storageKey: StorageKey,
): UserDataResource | undefined => {
  return (user.user_data || []).find(
    (record) =>
      record.name === storageKey.name && record.version === storageKey.version,
  );
};
